<!-- 销售退货收货操作 -->
<template>
    <div>
        <div>
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="tabHeight">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主要信息 -->
                                <div v-if="scope.index == 0">
                                    <el-form label-width="140px" id="mainInfo" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                                        <el-row v-if="dataActionBox.actionType != 2">
                                            <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow == 1" :prop="formOneValue.entityField" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey"
                                                :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                                <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                                <df-date v-if="formOneValue.fieldType == 'date'" :isdisabled="formOneValue.isChange == 0 || dataActionBox.actionType == 1" :isShowLong="false"
                                                    v-model="sendDataInfo[formOneValue.entityField]"></df-date>
                                                <el-tooltip v-else-if="formOneValue.fieldType == 'extract'" class="item"
                                                    :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9" effect="dark"
                                                    :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                    <el-input clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                        @keyup.enter.native="openExComponents(formOneValue.extractId, formOneKey, formOneValue.entityField, formOneValue.nosetField)"
                                                        :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 1">
                                                        <el-button @click="openExComponents(formOneValue.extractId, formOneKey, formOneValue.entityField, formOneValue.nosetField)" slot="append" icon="el-icon-search"
                                                            :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 1"></el-button>
                                                    </el-input>
                                                </el-tooltip>
                                                <el-input clearable :disabled="formOneValue.isChange == 0" @keyup.enter.native="nextFocus(formOneKey)" v-else v-model.trim="sendDataInfo[formOneValue.entityField]"></el-input>
                                            </el-form-item>
                                        </el-row>
                                        <el-row v-if="dataActionBox.actionType == 2">
                                            <el-form-item :label="formOneValue.showField + ':'" :prop="formOneValue.entityField" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey"
                                                :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                                <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)+':'"></label>
                                                <span v-if="formOneValue.isRift == 1">
                                                    <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                                                        sendDataInfo[formOneValue.entityField] }}</a>
                                                </span>
                                                <span v-else-if="formOneValue.entityField == 'opmId'">{{
                                                    sendDataInfo.opmName
                                                }}</span>
                                                <span v-else-if="formOneValue.entityField == 'cmId'">{{ sendDataInfo.cmName
                                                }}</span>
                                                <span v-else-if="formOneValue.entityField == 'depId'">{{
                                                    sendDataInfo.depName
                                                }}</span>
                                                <span v-else-if="formOneValue.entityField == 'salesId'">{{
                                                    sendDataInfo.salesName }}</span>
                                                <span v-else-if="formOneValue.fieldType == 'date'">
                                                    <span v-if="sendDataInfo[formOneValue.entityField]">
                                                        {{
                                                            $common.getLocalTime(sendDataInfo[formOneValue.entityField])
                                                        }}
                                                    </span>
                                                </span>
                                                <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                            </el-form-item>
                                        </el-row>
                                    </el-form>

                                    <el-form :inline="true" size="mini">
                                        <!-- 操作 -->
                                        <div id="operateBtn" v-if="dataActionBox.actionType != 2">
                                            <el-button type="primary" size="mini" @click="deleteDetails()" :disabled="sendDataInfo.desuRgregoDetailVos.length == 0">删除明细</el-button>
                                        </div>
                                        <!-- 明细 -->
                                        <el-table :data="sendDataInfo.desuRgregoDetailVos" ref="mxTableRef" :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent" @selection-change="handleSelectionChange"
                                            :height="mxHeight" id="mxTable" border style="width: 100%" size="mini">
                                            <el-table-column width="80" label="选择" v-if="dataActionBox.actionType != 2">
                                                <template slot-scope="scope">
                                                    <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                                                        <i class="el-icon-thumb"></i>
                                                    </el-radio>
                                                </template>
                                            </el-table-column>
                                            <el-table-column :prop="formOneValue.entityField" :label="formOneValue.showField" show-overflow-tooltip :min-width="formOneValue.fieldWeight" v-for="(formOneValue, formOneKey) in mxForm"
                                                :key="formOneKey" v-if="formOneValue.isShow == 1">
                                                <template slot-scope="scope">
                                                    <!-- 有效期 -->
                                                    <span v-if="formOneValue.fieldType == 'date'">
                                                        <span v-if="sendDataInfo.desuRgregoDetailVos[scope.$index][formOneValue.entityField]">
                                                            {{ $common.getLocalTime(scope.row[formOneValue.entityField]) }}
                                                        </span>
                                                    </span>
                                                    <!-- 已退数量 -->
                                                    <span v-else-if="formOneValue.entityField == 'returnNum'">
                                                        {{
                                                            sendDataInfo.desuRgregoDetailVos[scope.$index][formOneValue.entityField]
                                                        }}
                                                    </span>
                                                    <!-- 退货数量 -->
                                                    <span v-else-if="formOneValue.entityField == 'rgadRetnumber'">
                                                        {{
                                                            sendDataInfo.desuRgregoDetailVos[scope.$index][formOneValue.entityField]
                                                        }}
                                                    </span>
                                                    <span v-else-if="formOneValue.isRift == 1">
                                                        <a @click="toDetail(sendDataInfo.desuRgregoDetailVos[scope.$index][formOneValue.riftField])">{{
                                                                sendDataInfo.desuRgregoDetailVos[scope.$index][formOneValue.entityField]
                                                            }}</a>
                                                    </span>
                                                    <!-- 收货数量 -->
                                                    <el-input v-else-if="formOneValue.entityField == 'rgrdRecenum' && dataActionBox.actionType != 2" :ref="formOneValue.entityField"
                                                        @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" v-model="sendDataInfo.desuRgregoDetailVos[scope.$index][formOneValue.entityField]" type="number"
                                                        :min="0"></el-input>
                                                    <!-- 拒收数量 -->
                                                    <el-input v-else-if="formOneValue.entityField == 'rgrdRejenum' && dataActionBox.actionType != 2" :ref="formOneValue.entityField"
                                                        @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" v-model="sendDataInfo.desuRgregoDetailVos[scope.$index][formOneValue.entityField]" type="number"
                                                        :min="0"></el-input>
                                                    <!-- 拒收原因 -->
                                                    <el-input v-else-if="formOneValue.entityField == 'rgadReserves1' && dataActionBox.actionType != 2" :ref="formOneValue.entityField"
                                                        @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" v-model.trim="sendDataInfo.desuRgregoDetailVos[scope.$index][formOneValue.entityField]"></el-input>
                                                    <!-- 备注	 -->
                                                    <el-input v-else-if="formOneValue.entityField == 'rgrdRemark' && dataActionBox.actionType != 2" :ref="formOneValue.entityField"
                                                        @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" v-model.trim="sendDataInfo.desuRgregoDetailVos[scope.$index][formOneValue.entityField]"></el-input>
                                                    <span v-else>
                                                        {{
                                                            sendDataInfo.desuRgregoDetailVos[scope.$index][formOneValue.entityField]
                                                        }}
                                                    </span>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </el-form>
                                </div>
                                <!-- 冷链信息 -->
                                <div v-if="scope.index == 1">
                                    <el-form label-width="120px" id="mainInfo" class="baseForm" size="mini" :show-message="false">
                                        <el-row v-if="dataActionBox.actionType != 2">
                                            <template v-for="(formOneValue, formOneKey) in scope.row.jurconfigform">
                                                <el-form-item :label="formOneValue.showField" v-if="formOneValue.isShow == 1" :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                                    <!-- 系统字段 -->
                                                    <div v-if="formOneValue.isReserved == 0">
                                                        <el-date-picker :disabled="formOneValue.isChange == 0" @change="timeBlur(formOneKey)" v-if="formOneValue.fieldType == 'date'"
                                                            v-model="sendDataInfo.pisRegoCtri[formOneValue.entityField]" type="datetime" placeholder="选择日期" value-format="timestamp">
                                                        </el-date-picker>
                                                        <el-date-picker clearable :disabled="formOneValue.isChange == 0" @change="timeBlur(formOneKey)" v-if="formOneValue.fieldType == 'dateTime'"
                                                            v-model="sendDataInfo.pisRegoCtri[formOneValue.entityField]" type="datetime" placeholder="选择日期" value-format="timestamp">
                                                        </el-date-picker>
                                                        <el-input v-else-if="formOneValue.fieldType == 'search'" clearable v-model="sendDataInfo.pisRegoCtri[formOneValue.entityField]" :ref="formOneValue.entityField"
                                                            :id="formOneValue.entityField" @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                            :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                                            <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"
                                                                :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                                            </el-button>
                                                        </el-input>
                                                        <div v-else-if="formOneValue.entityField == 'coldPicture'">
                                                            <input style="display: none;" type="file" id="recordExcel" multiple name="recordExcel" @change="(e) => { fileUpload(e.target.files, e.target.files.length, 0, e) }" />
                                                            <ul v-if="sendDataInfo.pisRegoCtri[formOneValue.entityField]" class="upload">
                                                                <li v-for="(val,key) in sendDataInfo.pisRegoCtri[formOneValue.entityField]" :key="key">
                                                                    <i class="el-icon-error del" @click="delRemove(key)"></i>
                                                                    <cusImage style="width: 40px; height: 40px;" :src="`${imgUrl}/${val}`" :preview-src-list="[`${imgUrl}/${val}`]">
                                                                    </cusImage>
                                                                </li>
                                                                <li>
                                                                    <label for="recordExcel" class="image_label">
                                                                        <i class="el-icon-plus icon"></i>
                                                                    </label>
                                                                </li>
                                                            </ul>
                                                            <ul v-else class="upload">
                                                                <li>
                                                                    <label for="recordExcel" class="image_label">
                                                                        <i class="el-icon-plus icon"></i>
                                                                    </label>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        <el-input v-else @keyup.enter.native="nextFocus(formOneKey)" v-model.trim="sendDataInfo.pisRegoCtri[formOneValue.entityField]" maxlength="$store.state.inputLength"></el-input>
                                                    </div>
                                                </el-form-item>
                                            </template>
                                        </el-row>
                                        <el-row v-if="dataActionBox.actionType == 2">
                                            <el-form-item :label="formOneValue.showField + ':'" v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                                                <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)+':'"></label>
                                                <span v-if="sendDataInfo.pisRegoCtri && sendDataInfo.pisRegoCtri != null">
                                                    <span v-if="formOneValue.isRift == 1">
                                                        <a @click="toDetail(sendDataInfo.pisRegoCtri[formOneValue.riftField])">{{
                                                                sendDataInfo.pisRegoCtri[formOneValue.entityField] }}</a>
                                                    </span>
                                                    <span v-else-if="formOneValue.fieldType == 'dateTime'">
                                                        <span v-if="sendDataInfo.pisRegoCtri[formOneValue.entityField]">
                                                            {{
                                                                $common.getLocalTime(sendDataInfo.pisRegoCtri[formOneValue.entityField],
                                                                    true) }}
                                                        </span>
                                                    </span>
                                                    <span v-else-if="formOneValue.fieldType == 'date'">
                                                        <span v-if="sendDataInfo.pisRegoCtri[formOneValue.entityField]">
                                                            {{
                                                                $common.getLocalTime(sendDataInfo.pisRegoCtri[formOneValue.entityField])
                                                            }}
                                                        </span>
                                                    </span>
                                                    <span v-else-if="formOneValue.entityField == 'coldPicture'">
                                                        <ul v-if="sendDataInfo.pisRegoCtri[formOneValue.entityField]" class="upload">
                                                            <li v-for="(val,key) in sendDataInfo.pisRegoCtri[formOneValue.entityField]" :key="key">
                                                                <cusImage style="width: 40px; height: 40px;" :src="`${imgUrl}/${val}`" :preview-src-list="[`${imgUrl}/${val}`]">
                                                                </cusImage>
                                                            </li>
                                                        </ul>
                                                    </span>
                                                    <span v-else>{{ sendDataInfo.pisRegoCtri[formOneValue.entityField]
                                                    }}</span>
                                                </span>
                                            </el-form-item>
                                        </el-row>
                                    </el-form>
                                    <el-form :inline="true" size="mini">
                                        <!-- 操作 -->
                                        <div style="margin-bottom: 10px;" id="operateBtn" v-if="dataActionBox.actionType != 2">
                                            <el-form-item>
                                                <el-button type="primary" size="mini" @click="deleteDetails()" :disabled="sendDataInfo.desuRgregoDetailVos.length == 0">删除明细</el-button>
                                            </el-form-item>
                                        </div>
                                        <!-- 明细 -->
                                        <el-table :data="sendDataInfo.desuRgregoDetailVos" ref="mxTableRef" :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent" @selection-change="handleSelectionChange"
                                            :height="mxHeight" id="mxTable" border style="width: 100%" size="mini">
                                            <el-table-column width="80" label="选择" v-if="dataActionBox.actionType != 2">
                                                <template slot-scope="scope">
                                                    <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                                                        <i class="el-icon-thumb"></i>
                                                    </el-radio>
                                                </template>
                                            </el-table-column>
                                            <el-table-column :prop="formOneValue.entityField" :label="formOneValue.showField" show-overflow-tooltip :min-width="formOneValue.fieldWeight" v-for="(formOneValue, formOneKey) in mxForm"
                                                :key="formOneKey" v-if="formOneValue.isShow == 1">
                                                <template slot-scope="scope">
                                                    <!-- 有效期 -->
                                                    <span v-if="formOneValue.fieldType == 'date'">
                                                        <span v-if="sendDataInfo.desuRgregoDetailVos[scope.$index][formOneValue.entityField]">
                                                            {{ $common.getLocalTime(scope.row[formOneValue.entityField]) }}
                                                        </span>
                                                    </span>
                                                    <!-- 已退数量 -->
                                                    <span v-else-if="formOneValue.entityField == 'returnNum'">
                                                        {{
                                                            sendDataInfo.desuRgregoDetailVos[scope.$index][formOneValue.entityField]
                                                        }}
                                                    </span>
                                                    <!-- 退货数量 -->
                                                    <span v-else-if="formOneValue.entityField == 'rgadRetnumber'">
                                                        {{
                                                            sendDataInfo.desuRgregoDetailVos[scope.$index][formOneValue.entityField]
                                                        }}
                                                    </span>
                                                    <span v-else-if="formOneValue.isRift == 1">
                                                        <a @click="toDetail(sendDataInfo.desuRgregoDetailVos[scope.$index][formOneValue.riftField])">{{
                                                                sendDataInfo.desuRgregoDetailVos[scope.$index][formOneValue.entityField]
                                                            }}</a>
                                                    </span>
                                                    <!-- 收货数量 -->
                                                    <el-input v-else-if="formOneValue.entityField == 'rgrdRecenum' && dataActionBox.actionType != 2" :ref="formOneValue.entityField"
                                                        @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" v-model="sendDataInfo.desuRgregoDetailVos[scope.$index][formOneValue.entityField]" type="number"
                                                        :min="0"></el-input>
                                                    <!-- 拒收数量 -->
                                                    <el-input v-else-if="formOneValue.entityField == 'rgrdRejenum' && dataActionBox.actionType != 2" :ref="formOneValue.entityField"
                                                        @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" v-model="sendDataInfo.desuRgregoDetailVos[scope.$index][formOneValue.entityField]" type="number"
                                                        :min="0"></el-input>
                                                    <!-- 拒收原因 -->
                                                    <el-input v-else-if="formOneValue.entityField == 'rgadReserves1' && dataActionBox.actionType != 2" :ref="formOneValue.entityField"
                                                        @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" v-model.trim="sendDataInfo.desuRgregoDetailVos[scope.$index][formOneValue.entityField]"></el-input>
                                                    <!-- 备注	 -->
                                                    <el-input v-else-if="formOneValue.entityField == 'rgrdRemark' && dataActionBox.actionType != 2" :ref="formOneValue.entityField"
                                                        @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" v-model.trim="sendDataInfo.desuRgregoDetailVos[scope.$index][formOneValue.entityField]"></el-input>
                                                    <span v-else>
                                                        {{
                                                            sendDataInfo.desuRgregoDetailVos[scope.$index][formOneValue.entityField]
                                                        }}
                                                    </span>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </el-form>
                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <tree v-if="dataActionBox.actionType == 2" ref="tree" @tabHeight="(val) => { mxHeight = val }"></tree>

                <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :sendDataInfo="sendDataInfo" @initActionBox="initActionBox" @sendDataAction="sendDataAction" @showPrintPlan="showPrintPlan"></v-foot>
            </div>
        </div>
        <printPlan ref="printPlan"></printPlan>
        <el-dialog top="1vh" :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :width="exWidth" :modal-append-to-body='true' :append-to-body="true">
            <ExtractionScheme ref="extractionScheme" :ppId="ppId" :id="exId" @TranData="getExData" @getWidth="getExWidth" @sendTitle="getExtractName" />
        </el-dialog>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import {
    addCheckSuColdChain
} from "@/service/api.js";
import NP from 'number-precision'
import ExtractionScheme from '../byComponents/ExtractionScheme.vue'
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
    name: 'salesReceivingAction',
    props: ['actionData'],
    //import引入的组件需要注入到对象中才能使用
    components: {
        ExtractionScheme,
        SearchScheme
    },
    data() {
        //这里存放数据
        return {
            imgUrl: window.global_config.BASE_IMG_URL,
            dataActionBox: {
                showStatus: false,
                openMode: 'ltr' || 'rtl',
                boxTitle: '新增' || '编辑',
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {
                desuRgregoDetailVos: [],
                payMethod: '',
                settleMethod: '',
                credit: '',
                dismode: '',
                pisRegoCtri: {
                    psrgciArrtem: "",
                    psrgciArrtime: "",  //到货时间
                    psrgciRemark: "",
                    psrgciStrantem: "",
                    psrgciStrantime: "",    //起运时间
                    psrgciTconmode: "",
                    psrgciTranmode: "",
                    trafficUnit: "",    //运输单位
                    haulTool: "",   //运输工具
                    hippingLocation: "", //发运地点
                    numberPlate: "",    //车牌号
                    controlStatus: "",  //温控状况
                    highTemperature: "", //在途最高温度
                    lowTemperature: "", //在途最低温度
                    coldPicture: [],//温湿度记录
                },
                coId: '',
                coName: '',
                rgaiAccperiod: "",
                rgaiDismode: "",
                rgaiPaymode: "",
                rgaiReserves1: "",
                rgaiReserves2: "",
                rgaiReserves3: "",
                rgaiReserves4: "",
                rgaiReserves5: "",
                rgaiReserves6: "",
                rgaiSetmode: "",
                salesId: "",
                salesIdName: "",
                rgaiId: '',
                rgamId: '',
                opmId: '',
                cmId: '',
                rgamRapdate: '',
                rgrmRemark: "",
                rgrmReserves1: "",
                rgrmReserves2: "",
                rgrmReserves3: "",
                rgrmReserves4: "",
                rgrmReserves5: "",
                rgrmReserves6: "",
                depId: '',
                depName: '',
                totalCount: 0,
                totalMoney: 0,
                totalNumber: 0,
                wobkemId: '',

            },

            showTabs: '',
            formDataList: [],
            dictionariesData: {},
            userOneList: [],
            exTitle: '',//缓存提取
            exWidth: '',
            DialogExtract: false,
            ppId: 'rgamId',	//rgadId	销售退货申请明细ID,rgamId	销售退回申请单号
            exId: '',
            selectedDetailsIndex: 0,	//选择明细索引
            mxHeight: 0,
            tabForm: [], // tab循环的主表单
            mxForm: [],
            footForm: [],
            sField: '', // 赋值字段
            fField: '', //焦点字段
            nosField: '', // 不可赋值字段
            inputel: '', //所有input对象
            seTitle: "", //检索
            DialogVisible: false,
            seId: 0,
            seType: "",
            seIndex: 0,
            seWidth: '',
            parentSearchData: {},
            selectedRow: [], // 当前已选择行
        };
    },
    //监听属性 类似于data概念
    computed: {
    },
    //监控data中的数据变化
    watch: {
        'sendDataInfo.desuRgregoDetailVos': {
            handler: function (newValue, oldValue) {
                this.sendDataInfo.totalMoney = 0
                this.sendDataInfo.totalNumber = 0
                this.sendDataInfo.totalCount = 0
                newValue.forEach((item, keys) => {
                    let a = item.rgrdRecenum
                    if (item.rgrdRecenum == '') {
                        item.rgrdRecenum = 0
                    }
                    if (item.rgrdRejenum == '') {
                        item.rgrdRejenum = 0
                    }
                    //	rgadRetnumber退货数量, rgrdRecenum收货数量, rgrdRejenum拒收数量
                    if (item.rgadRetnumber - item.rgrdRejenum < item.rgrdRecenum) {
                        this.$message({
                            message: '收货数量+拒收数量不得大于退货数量',
                            type: 'warning'
                        })
                        this.sendDataInfo.desuRgregoDetailVos[keys].rgrdRecenum = 0
                        this.sendDataInfo.desuRgregoDetailVos[keys].money = 0
                        this.sendDataInfo.desuRgregoDetailVos[keys].psmoney = 0
                        this.sendDataInfo.desuRgregoDetailVos[keys].costMoney = 0	//成本金额
                        this.sendDataInfo.desuRgregoDetailVos[keys].gross = 0	//毛利
                        this.sendDataInfo.desuRgregoDetailVos[keys].costAmount = 0	//成本金额
                        return false
                    }
                    if (item.rgrdRecenum > item.rgadRetnumber) {
                        this.sendDataInfo.desuRgregoDetailVos[keys].rgrdRecenum = item.rgadRetnumber
                        this.sendDataInfo.desuRgregoDetailVos[keys].rgrdRejenum = 0
                    }
                    var psMoney = this.$common.getDecimalInfo(3, NP.times(item.psprice, item.rgrdRecenum))
                    var money = this.$common.getDecimalInfo(3, NP.times(item.price, item.rgrdRecenum))
                    this.sendDataInfo.desuRgregoDetailVos[keys].money = money // 金额
                    this.sendDataInfo.desuRgregoDetailVos[keys].psmoney = psMoney // 含税金额

                    this.sendDataInfo.desuRgregoDetailVos[keys].costMoney =
                        this.$common.getDecimalInfo(3, NP.times(item.woadWcost, item.rgrdRecenum))	//含税成本金额
                    this.sendDataInfo.desuRgregoDetailVos[keys].saleQumoney =
                        this.$common.getDecimalInfo(3, NP.times(item.saleQuprice || 0, item.rgrdRecenum))	//报价金额
                    this.sendDataInfo.desuRgregoDetailVos[keys].costAmount =
                        this.$common.getDecimalInfo(3, NP.times(item.costPrice, item.rgrdRecenum))	//成本金额

                    this.sendDataInfo.desuRgregoDetailVos[keys].gross =
                        this.$common.getDecimalInfo(3, NP.minus(NP.times(item.psprice, item.rgrdRecenum), NP.times(item.woadWcost, item.rgrdRecenum)))	//毛利

                    this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(3, NP.plus(this.sendDataInfo.totalMoney, psMoney))
                    this.sendDataInfo.totalNumber = this.$common.getDecimalInfo(1, NP.plus(this.sendDataInfo.totalNumber, item.rgrdRecenum))
                })
                this.sendDataInfo.totalCount = newValue.length//
            },
            deep: true,
        }
    },
    //方法集合
    methods: {
        delRemove(key) {
            this.sendDataInfo.pisRegoCtri.coldPicture.splice(key, 1)
        },
        async fileUpload(files, length, index, e) {
            if (length - 1 >= index) {
                const params = {
                    file: files[index]
                }
                const response = await this.$http.uploadFile(params, true)
                if (response.status == 200) {
                    this.sendDataInfo.pisRegoCtri.coldPicture.push(response.result[0].fileUrl)
                    this.fileUpload(files, length, index + 1, e)
                } else {
                    e.target.value = ""
                    this.$message.error(response.message)
                }
            } else {
                e.target.value = ""
            }
        },
        tabHeight(val) {
            this.mxHeight = val
        },
        // 检索方案        
        openSearch(sId, index, type, sField, fField, nosField) {
            this.DialogVisible = true;
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField
            this.fField = fField
            this.nosField = nosField
            this.parentSearchData[type] = this.sendDataInfo.pisRegoCtri[type]
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        changeInputModel(val) {
            // debuggger
            if (val != "" || val != undefined) {
                if (this.sField == "psrgciTranmode") {
                    this.sendDataInfo.pisRegoCtri[this.sField] = val[this.sField]
                } else {
                    this.paramValue(val)
                }
            }
            this.DialogVisible = false;
        },
        paramValue(val) {
            console.log(val)
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.sendDataInfo.pisRegoCtri[item] = val[item]
            })
            this.$nextTick(() => {
                this.nextFocus(this.seIndex)
            })
        },

        // 获取冷链表单所有input
        getMainInput() {
            var el = document.getElementById('mainInfo')
            if (el) this.inputel = el.getElementsByTagName('input')
        },

        // 主表单select框切换enter切换焦点事件方法
        selectChange(e) {
            if (e == false) {
                for (let index = 0; index < this.inputel.length; index++) {
                    if (this.inputel[index] == document.activeElement) {
                        this.nextFocus(index)
                        break
                    }
                }
            }
        },
        closeChild() {
            addEventListener('keyup', this.keyUp)//创建监听键盘事件
        },
        // 输入框切换焦点
        nextFocus(index) {
            if (index >= (this.inputel.length - 1)) {
                if (this.sendDataInfo.desuRgregoDetailVos.length > 0) {
                    this.tableNextFocus('rgrdRecenum', 0)
                }
                return
            }
            var aindex = index + 1
            if (this.inputel[aindex].value != '' || this.inputel[aindex].disabled) {
                this.nextFocus(aindex)
                return
            }
            this.inputel[aindex].focus()
        },
        // 时间框失去焦点
        timeBlur(index) {
            this.nextFocus(index)
        },
        // 初始化焦点
        initFocus() {
            for (let index = 0; index < this.inputel.length; index++) {
                if (this.inputel[index].value == '') {
                    this.inputel[index].focus()
                    break
                }
            }
        },

        // 表格切换焦点方法
        tableNextFocus(field, index) {
            if (field == 'keydown') {
                if (index == this.sendDataInfo.desuRgregoDetailVos.length - 1) return
                if (this.sendDataInfo.desuRgregoDetailVos[index + 1] != undefined) {
                    this.$refs['rgrdRecenum'][index + 1].focus() //跳到货数量
                    this.selectedDetailsIndex = index + 1
                    this.$nextTick(() => {
                        let refsElTable = this.$refs.mxTableRef
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(this.sendDataInfo.desuRgregoDetailVos[this.selectedDetailsIndex]);
                    })
                    return
                }
            }
            this.$refs[field][index].focus()
        },

        // 监听键盘事件
        keyUp(e) {
            if (e.key == 'F1') { // 右键新增明细
                e.preventDefault();
                // this.addDetail('sendDataInfo')
                return
            } else if (e.key == 'F2') {
                e.preventDefault();
                this.deleteDetails()
            } else if (e.keyCode == 40) { // 下键
                // 表格为空，不执行下方 
                if (this.sendDataInfo.desuRgregoDetailVos.length == 0) return
                let refsElTable = this.$refs.mxTableRef
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) { // 如果当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0
                    } else if (this.selectedDetailsIndex == this.sendDataInfo.desuRgregoDetailVos.length - 1) { // 如果选中的是最后一行了，那么下一行选中的是第一行
                        this.selectedDetailsIndex = 0
                    } else { // 正常递增
                        this.selectedDetailsIndex++
                    }
                    if (!refsElTable) return
                    let findRow = this.selectedRow.find(c => c.rowIndex == this.selectedDetailsIndex); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(this.sendDataInfo.desuRgregoDetailVos[this.selectedDetailsIndex], false);
                        return;
                    }
                    // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.sendDataInfo.desuRgregoDetailVos[this.selectedDetailsIndex]); // 把现在当前行勾选
                })
            } else if (e.keyCode == 38) { // 上键
                if (this.sendDataInfo.desuRgregoDetailVos.length == 0) return
                let refsElTable = this.$refs.mxTableRef
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) { // 当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0
                    } else if (this.selectedDetailsIndex == 0) { // 如果选中的是第一行了，那么下一行选中的是最后一行
                        this.selectedDetailsIndex = this.sendDataInfo.desuRgregoDetailVos.length - 1
                    } else { // 正常递减
                        this.selectedDetailsIndex--
                    }
                    if (!refsElTable) return
                    let findRow = this.selectedRow.find(c => c.rowIndex == this.selectedDetailsIndex); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(this.sendDataInfo.desuRgregoDetailVos[this.selectedDetailsIndex], false);
                        return;
                    }
                    // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.sendDataInfo.desuRgregoDetailVos[this.selectedDetailsIndex]); // 把现在当前行勾选
                })
            }

        },

        // 表格方法
        rowClassName({ row, rowIndex }) {
            let rowName = "",
                findRow = this.selectedRow.find(c => c.rowIndex === row.rowIndex);
            if (findRow) {
                rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },

        // 选中行底色逻辑
        rowStyle({ row, rowIndex }) {
            Object.defineProperty(row, "rowIndex", { // 给每行添加不可枚举属性rowIndex来标识当前行
                value: rowIndex,
                writable: true,
                enumerable: false
            });
            let rowBackground = {}
            if (row.bgColor && row.bgColor != '') rowBackground.backgroundColor = row.bgColor
            return rowBackground
        },

        // 明细表格点击选中
        clickEvent(row, column, event, params) {
            let refsElTable = this.$refs.mxTableRef; // 获取表格对象
            let findRow = {}
            this.selectedDetailsIndex = row.rowIndex
            findRow = this.selectedRow.find(c => c.rowIndex == row.rowIndex); //找出当前选中行
            //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
            if (findRow && this.selectedRow.length === 1) {
                refsElTable.toggleRowSelection(row, false);
                return;
            }
            // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(row);
        },

        // 保存已选择行
        handleSelectionChange(rows) {
            this.selectedRow = rows; // 保存已选择行
        },
        showPrintPlan() { // 打印方法
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(this.actionData.orderId, this.actionData.printSouce, this.actionData.printJurId)
            } else {
                return
            }
        },
        // 子组件穿透方法
        toDetail(orderId) {
            if (this.dataActionBox.actionType != 2) this.$parent.$parent.toDetail(orderId)
            else this.$parent.$parent.$parent.toDetail(orderId)
        },
        // 触发提取方案
        openExComponents(e, index, type, nosField) {
            console.log(type);
            this.seIndex = index
            this.nosField = nosField
            this.exId = e;
            if (type == 'rgamId') {
                this.init()
            }
            this.DialogExtract = true;
            removeEventListener('keyup', this.keyUp)
        },

        // 获取 提取单数据
        async getExData(val) {
            if (val != "" || val != undefined) {
                for (let key in val) {
                    if (key == "arrlistbychen") {
                        this.sendDataInfo.desuRgregoDetailVos = val[key]
                        this.sendDataInfo.desuRgregoDetailVos.forEach((item, i) => {
                            this.$set(this.sendDataInfo.desuRgregoDetailVos[i], "rgrdRecenum", item.rgadRetnumber);	//收货初始=退回
                            this.$set(this.sendDataInfo.desuRgregoDetailVos[i], "rgrdRejenum", 0);	//拒收
                        })
                    } else {
                        if (!this.nosFieldChange(key)) {
                            this.sendDataInfo[key] = val[key];
                        }
                    }
                }
                this.sendDataInfo.accountTime = new Date().getTime()
            } else {
                this.$message({
                    message: '未拿到数据',
                    type: 'error'
                })
            }
            this.DialogExtract = false
            addEventListener('keyup', this.keyUp)//创建监听键盘事件
            this.$nextTick(() => {
                this.selectedDetailsIndex = 0
                this.tableNextFocus('rgrdRecenum', this.seIndex)
                let refsElTable = this.$refs.mxTableRef
                refsElTable.clearSelection();
                refsElTable.toggleRowSelection(this.sendDataInfo.desuRgregoDetailVos[this.selectedDetailsIndex]);
            })
        },
        nosFieldChange(val) {
            var flag = false
            var arr = this.nosField.split(",")
            console.log(arr);
            arr.forEach(item => {
                if (item == val && !flag) {
                    flag = true
                }
            })
            return flag
        },
        getExWidth(e) {
            this.exWidth = e + "%";
        },
        getExtractName(e) {
            this.exTitle = e;
        },


        //确认
        async sendDataAction(formName) {
            let flag = false
            this.$refs[formName].validate((valid) => {
                if (valid) {

                } else {
                    this.$message({
                        message: '请完善必填信息',
                        type: 'error'
                    })
                    flag = true
                    return false;
                }
            })
            if (flag) return false;
            if (this.sendDataInfo.desuRgregoDetailVos.length < 1) {
                this.$message({
                    message: '请添加明细',
                    type: 'error'
                });
                return false
            }
            //收货+拒收 = 退回 //	rgadRetnumber退货数量, rgrdRecenum收货数量, rgrdRejenum拒收数量
            for (let i = 0; i < this.sendDataInfo.desuRgregoDetailVos.length; i++) {
                const item = this.sendDataInfo.desuRgregoDetailVos[i]
                if (item.rgadRetnumber) {//数量
                    item.rgadRetnumber = parseFloat(item.rgadRetnumber)
                    item.rgrdRecenum = parseFloat(item.rgrdRecenum)
                    item.rgrdRejenum = parseFloat(item.rgrdRejenum)
                    let doubleNum = item.rgrdRecenum + item.rgrdRejenum
                    if (item.rgadRetnumber < doubleNum) {//收货数量 = 合格数量+不合格数量
                        this.$message({
                            message: '请填写 ' + item.bgmName + ' 的合理数量',
                            type: 'error'
                        });
                        return false
                    }
                } else {
                    this.$message({
                        message: '请先检查明细数量',
                        type: 'error'
                    });
                    return false
                }
            }
            var flags = false
            this.sendDataInfo.desuRgregoDetailVos.forEach((item, index) => {
                if (item.rgrdRejenum > 0 && (item.rgadReserves1 == "" || item.rgadReserves1 == null) && !flags) {
                    this.selectedDetailsIndex = index
                    flags = true
                }
            })
            if (flags) {
                this.$message.error("拒收原因不能为空")
                this.tableNextFocus('rgadReserves1', this.selectedDetailsIndex)
                return
            }



            var flagNum = false
            var flag1 = false
            var flagPsmoney = false
            var flagMoney = false
            var flagPrice = false
            var indexNum = 0
            var indexNum1 = 0
            var indexNum2 = 0
            var indexNum3 = 0
            var indexNum4 = 0
            this.sendDataInfo.desuRgregoDetailVos.forEach((item, index) => {
                var num = 0
                if ((item.rgrdRecenum == "" || item.rgrdRecenum == null || item.rgrdRecenum <= 0) && (item.rgrdRejenum == "" || item.rgrdRejenum == null || item.rgrdRejenum <= 0) && !flagNum) {
                    indexNum3 = index
                    flagNum = true
                }else if (item.rgrdRecenum > 0) {
                    num=item.rgrdRecenum
                }
                if ((item.psprice == "" || item.psprice == null || item.psprice <= 0) && (item.psmoney == "" || item.psmoney == null || item.psmoney <= 0) && (item.price == "" || item.price == null || item.price <= 0) && (item.money == "" || item.money == null || item.money <= 0)) {

                } else if (item.psprice > 0 && item.psmoney > 0 && item.price > 0 && item.money > 0) {
                    var psMoney = this.$common.getDecimalInfo(3, NP.times(item.psprice, Number(num)))
                    console.log(psMoney, item.psmoney);
                    if (this.$common.getDecimalInfo(3, NP.times(item.psprice, Number(num))) != item.psmoney && !flagPsmoney) {
                        indexNum = index
                        flagPsmoney = true
                    }
                    var midmoney = NP.times(item.price, num)
                    console.log(this.$common.getDecimalInfo(3, midmoney), item.money);
                    if (this.$common.getDecimalInfo(3, midmoney) != item.money && !flagMoney) {
                        indexNum1 = index
                        flagMoney = true
                    }
                    console.log(this.$common.getDecimalInfo(2, NP.divide(midmoney, num)), item.price);
                    if (this.$common.getDecimalInfo(2, NP.divide(midmoney, num)) != item.price && !flagPrice) {
                        indexNum2 = index
                        flagPrice = true
                    }
                }
            })
            if (flagNum) {
                return this.$message.error(`第${indexNum3 + 1}行的${this.sendDataInfo.desuRgregoDetailVos[indexNum3].bgmName}数量不能为空或为零！`)
            }
            if (flagPsmoney) {
                return this.$message.error(`第${indexNum + 1}行的${this.sendDataInfo.desuRgregoDetailVos[indexNum].bgmName}含税金额计算规则不符！`)
            }
            if (flagMoney) {
                return this.$message.error(`第${indexNum1 + 1}行的${this.sendDataInfo.desuRgregoDetailVos[indexNum1].bgmName}金额计算规则不符！`)
            }
            if (flagPrice) {
                return this.$message.error(`第${indexNum2 + 1}行的${this.sendDataInfo.desuRgregoDetailVos[indexNum2].bgmName}价格计算规则不符！`)
            }
            let sendData = JSON.parse(JSON.stringify(this.sendDataInfo))
            if (this.dataActionBox.actionType == 0) {
                var responseData = await this.$http.addSalesReceiving(sendData)
            } else {
                var responseData = await this.$http.setSalesReceiving(sendData)
            }
            if (responseData.status == 200) {
                this.$emit('drawerCancel')
                this.init()
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });


            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },

        deleteDetails() {
            this.sendDataInfo.desuRgregoDetailVos.splice(this.selectedDetailsIndex, 1)
            this.$nextTick(() => {
                if (this.sendDataInfo.desuRgregoDetailVos.length > 1) {
                    this.selectedDetailsIndex = Number(this.selectedDetailsIndex - 1)
                    this.tableNextFocus('rgrdRecenum', this.selectedDetailsIndex)
                } else {
                    this.selectedDetailsIndex = 0
                }
                console.log(this.selectedDetailsIndex)
                let refsElTable = this.$refs.mxTableRef
                refsElTable.clearSelection();
                refsElTable.toggleRowSelection(this.sendDataInfo.desuRgregoDetailVos[this.selectedDetailsIndex]);
            })
        },

        // 选择采购员
        selectUserOne(data) {
            data.forEach(item => {
                if (item.opmId == this.sendDataInfo.opmId) {
                    this.sendDataInfo.depId = item.depId
                    this.sendDataInfo.depName = item.depName
                }
            })
            // console.log(data)
        },
        //初始
        init() {
            for (let key in this.sendDataInfo) {
                if (key != "pisRegoCtri") {
                    this.sendDataInfo[key] = ''
                }
            }
            this.sendDataInfo.desuRgregoDetailVos = []

            this.sendDataInfo.rgamTotalmoney = 0
            this.sendDataInfo.rgamTotalnumber = 0
            this.sendDataInfo.rgamTotalcount = 0
            this.sendDataInfo.rgamRapdate = this.$moment().valueOf();
        },

        //取消
        initActionBox(formName) {
            this.$confirm('确定取消' + this.dataActionBox.boxTitle + '吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$common.delOrderInfo(this.sendDataInfo.rgamId)
                this.$emit('drawerCancel')
                this.init()
                this.$refs[formName].resetFields();
            }).catch(() => { })
        },
        //父级传入
        openBox() {
            this.dataActionBox.actionType = this.actionData.cate
            this.formDataList = this.actionData.formData
            var oldData = this.actionData.oldData
            this.showTabs = this.actionData.formData[0].jciName
            this.filterMainField()
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = '新增信息'
                this.dataActionBox.openMode = 'ltr'
            } else if (this.dataActionBox.actionType == 1) {
                this.dataActionBox.boxTitle = '编辑信息'
                this.dataActionBox.openMode = 'rtl'
                var dataInfo = JSON.parse(JSON.stringify(oldData))
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key])
                }
                if (dataInfo.pisRegoCtri && dataInfo.pisRegoCtri.coldPicture != undefined && dataInfo.pisRegoCtri.coldPicture != null && dataInfo.pisRegoCtri.coldPicture != "") {
                    this.$set(this.sendDataInfo.pisRegoCtri, 'coldPicture', dataInfo.pisRegoCtri.coldPicture)
                } else {
                    this.$set(this.sendDataInfo.pisRegoCtri, 'coldPicture', [])
                }
            } else {
                this.dataActionBox.boxTitle = '查看信息'
                var dataInfo = JSON.parse(JSON.stringify(oldData))
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key])
                }
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight()
                    } else {
                        this.$refs['tree'].init(this.sendDataInfo.rgrmId)
                        this.mxHeight = this.$common.getHeight()
                    }
                    this.initFocus()
                }, 16.7)
            })
        },

        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = []
            this.formDataList.forEach(item => {
                if (item.jciType == 1) {
                    mainFormList.push(item)
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform))
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform))
                }
            })
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key))
                this.tabForm[i].jurconfigform = []
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    if (key.jurconfigform[index].isShow == 1) this.tabForm[i].jurconfigform.push(key.jurconfigform[index])
                }
            })
            var arr = [{ entityField: "desuRgregoDetailVos" }]
            var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
            for (let key in obj) {
                this.$set(this.sendDataInfo, key, obj[key])
            }
            this.sendDataInfo.desuRgregoDetailVos = []
            this.sendDataInfo.rgamTotalmoney = 0
            this.sendDataInfo.rgamTotalnumber = 0
            this.sendDataInfo.rgamTotalcount = 0
            this.$set(this.sendDataInfo, 'rgamRapdate', new Date().getTime())
        },

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$nextTick(() => {
            this.openBox()
        })
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        document.onkeydown = function () {
            if (window.event.keyCode === 38 || window.event.keyCode === 40) {
                window.event.returnValue = false;
            }
        }
    },
    beforeCreate() {
    }, //生命周期 - 创建之前
    beforeMount() {
    }, //生命周期 - 挂载之前
    beforeUpdate() {
    }, //生命周期 - 更新之前
    updated() {
        this.getMainInput()
    }, //生命周期 - 更新之后
    beforeDestroy() {
    }, //生命周期 - 销毁之前
    destroyed() {
    }, //生命周期 - 销毁完成
    activated() {
    }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    /* height: 500px !important; */
    overflow-y: auto;
}

.el-drawer {
    outline: none;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
    width: 100%;
}

.oldInput {
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: 0;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 90%;
}

#mxTable .el-form-item--mini.el-form-item,
#mxTable .el-form-item--small.el-form-item {
    margin-bottom: 0;
}

/* 上传图片 */
.upload {
    width: 200px;
    list-style: none;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.upload li {
    position: relative;
    width: 42px;
    height: 42px;
    margin-right: 5px;
    margin-bottom: 5px;
    border: 1px solid #dedede;
}

.image_label {
    display: block;
    width: 42px;
    height: 42px;
}

.upload li:last-child {
    border: none;
}

.upload li:last-child .image_label {
    border: 1px dashed #838383;
}

.upload li:last-child .image_label:hover {
    border: 1px dashed #409eff;
    cursor: pointer;
}

.upload li:last-child:hover .icon {
    color: #409eff;
}

.upload li .icon {
    color: #838383;
    font-size: 20px;
    margin: 10px 0 0 10px;
}

.del {
    display: none;
    position: absolute;
    top: 0px;
    right: 0px;
    font-size: 14px;
    z-index: 99;
    cursor: pointer;
}

.del:hover {
    color: #409eff;
}

.upload li:hover .del {
    display: inline-block;
}

::v-deep .el-image__error {
    font-size: 7px;
}

::v-deep .cus-image {
    width: 40px !important;
    height: 40px !important;
}

::v-deep .cus-image img {
    width: 40px !important;
    height: 40px !important;
}
</style>